/* Reuse PW's drawer lifecycle; only mobile menu panels and keyboard focus live here. */
(() => {
  const drawer = document.getElementById('MobileMenu');
  if (!drawer || drawer.dataset.pwMenuReady) return;
  drawer.dataset.pwMenuReady = 'true';
  const menu = drawer.querySelector('.pw-menu');
  if (!menu) return;
  const phone = window.matchMedia('(max-width: 699px)');
  const pages = [...menu.querySelectorAll('.pw-menu__page')];
  const root = menu.querySelector('[data-menu-root]');
  const footer = menu.querySelector('.pw-menu__footer');
  const close = menu.querySelector('.pw-menu__close');
  const openers = [...document.querySelectorAll('[data-open-drawer="MobileMenu"]')];
  const reset = () => {
    menu.querySelector(".pw-menu__pages").scrollTop = 0;
    pages.forEach(page => { page.hidden = page !== root; });
    footer.hidden = false;
    menu.querySelectorAll('[data-menu-panel]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    menu.querySelectorAll('details[open]').forEach(details => { details.open = false; });
  };
  let wasOpen = drawer.classList.contains('is-open');
  new MutationObserver(() => {
    const opened = drawer.classList.contains('is-open');
    if (opened === wasOpen) return;
    wasOpen = opened;
    openers.forEach(button => button.setAttribute('aria-expanded', String(opened)));
    reset();
    if (opened && phone.matches) close.focus({preventScroll: true});
  }).observe(drawer, {attributes: true, attributeFilter: ['class']});
  menu.addEventListener('click', event => {
    const control = event.target.closest('[data-menu-panel], [data-menu-back]');
    if (!control || !phone.matches) return;
    const id = control.dataset.menuPanel || control.dataset.menuBack;
    const target = pages.find(page => page.id === id);
    if (!target) return;
    const previous = pages.find(page => !page.hidden);
    pages.forEach(page => { page.hidden = page !== target; });
    footer.hidden = target !== root;
    menu.querySelector(".pw-menu__pages").scrollTop = 0;
    if (control.dataset.menuPanel) {
      control.setAttribute('aria-expanded', 'true');
      target.querySelector('button, a')?.focus();
    } else {
      const parentControl = [...target.querySelectorAll('[data-menu-panel]')].find(button => button.dataset.menuPanel === previous?.id);
      parentControl?.setAttribute('aria-expanded', 'false');
      (parentControl || target.querySelector('button, a'))?.focus();
    }
  });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !phone.matches || !drawer.classList.contains('is-open')) return;
    const focusable = [...menu.querySelectorAll('a[href],button:not([disabled]),summary')].filter(element => element.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
})();
